import React from 'react'
import PropTypes from 'prop-types'
import { filterLazyProps } from './helpers'

const LazyParagraph = ({ content, setContentRef, ...props }) =>
  <p ref={ setContentRef } dangerouslySetInnerHTML={{ __html: content }} { ...filterLazyProps(props) } />

LazyParagraph.propTypes = {
  content: PropTypes.string,
  setContentRef: PropTypes.func
}

export default LazyParagraph
